import { SomethingWentWrongDS } from '@src/components/blocks/something-went-wrong-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import SomethingWentWrongLegacy from './something-went-wrong-legacy'

import type { SomethingWentWrongProps } from './something-went-wrong.types'

/**
 * Thin DS router. Kept at this path (and still the default export) so the 20+ existing callers
 * import it unchanged.
 */
function SomethingWentWrong(props: SomethingWentWrongProps) {
  if (shouldUseDesignSystem()) {
    return <SomethingWentWrongDS {...props} />
  }

  return <SomethingWentWrongLegacy {...props} />
}

export default SomethingWentWrong
export type { SomethingWentWrongProps } from './something-went-wrong.types'
